import { FiCpu, FiDatabase, FiGrid, FiInbox, FiUserCheck, FiUsers } from 'react-icons/fi';
import { FaUsers, FaWhatsapp } from 'react-icons/fa';

/**
 * Single source of truth for navigation.
 *
 * Consumed by:
 *   - Sidebar (grouped rendering)
 *   - Breadcrumb (path → labels)
 *   - CommandPalette (navigation commands)
 *   - useGlobalShortcuts (keyboard chords)
 */
export const NAV_SECTIONS = [
  {
    id: 'overview',
    label: 'Overview',
    items: [
      { id: 'dashboard', label: 'Dashboard', path: '/', icon: FiGrid, shortcut: 'g d' },
    ],
  },
  {
    id: 'tenancy',
    label: 'Tenancy',
    items: [
      { id: 'clients', label: 'Clients', path: '/clients', icon: FaUsers, shortcut: 'g c' },
      { id: 'partners', label: 'Partners', path: '/partners', icon: FiUserCheck, shortcut: 'g p' },
      {
        id: 'requests',
        label: 'Requests',
        path: '/client-requests',
        icon: FiInbox,
        shortcut: 'g r',
        badgeKey: 'pendingRequests', // Sidebar reads this key from the badges prop.
      },
    ],
  },
  {
    id: 'operations',
    label: 'Operations',
    items: [
      { id: 'migrations', label: 'Migrations', path: '/migrations', icon: FiDatabase, shortcut: 'g m' },
      { id: 'whatsapp', label: 'WhatsApp', path: '/whatsapp', icon: FaWhatsapp, shortcut: 'g w' },
      { id: 'ai-spend', label: 'Consommation IA', path: '/ai-spend', icon: FiCpu, shortcut: 'g i' },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    items: [
      { id: 'users', label: 'Users', path: '/users', icon: FiUsers, shortcut: 'g u' },
    ],
  },
];

/** Flat list with section metadata attached — useful for palette / breadcrumbs. */
export const ALL_NAV_ITEMS = NAV_SECTIONS.flatMap((section) =>
  section.items.map((item) => ({ ...item, sectionLabel: section.label, sectionId: section.id })),
);

/**
 * Match a pathname against NAV_ITEMS. Returns the best match
 * (longest-prefix) or null if none found.
 */
export function matchNavItem(pathname) {
  // Exact match first.
  const exact = ALL_NAV_ITEMS.find((i) => i.path === pathname);
  if (exact) return { item: exact, isExact: true };

  // Longest prefix match (e.g. '/partners/abc' → partners item).
  const sorted = [...ALL_NAV_ITEMS].sort((a, b) => b.path.length - a.path.length);
  const prefix = sorted.find(
    (i) => i.path !== '/' && (pathname === i.path || pathname.startsWith(i.path + '/')),
  );
  if (prefix) return { item: prefix, isExact: false };

  return null;
}
